import React, { useEffect, useState } from "react";
import DashboardCreator from "./DashboardCreator";
import { useDispatch, useSelector } from "react-redux";
import reportData from "./ReportLayoutData";
import { Button, Card, Table, Badge, Spinner, Form, Pagination } from "react-bootstrap";
import { getDashboard } from "../../redux/action/dashboardActions";
import SubscriptionExpireWarning from "./SubscriptionExpireWarning";
import { getAllRestaurants } from "../../redux/action/restaurantActions";
import {
  deleteOldPdfOrders,
  deleteTodayExpenses,
  deleteTodayOrders,
  generateDailyBalance,
  generateItemSummaryData,
  generateOrderSummaryData,
  generateRawMaterialData,
  moveTodayExpensetoExpense,
  moveTodayOrderToOrder,
  resetKotValue,
  getJobStatuses,
} from "../../redux/action/tempActions";

const Reports = () => {
  const { role, restaurantId, branchId, remainingDays } = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();

  const { data } = useSelector((state) => state.dashboard);
  const allRestaurants = useSelector((state) => state.restaurant?.allRestaurants || []);
  const [jobStatuses, setJobStatuses] = useState([]);
  const [loadingStatuses, setLoadingStatuses] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const CurrentReport = reportData[role];
  const CurrentReportData = CurrentReport?.dashboardData;

  const fetchJobStatuses = () => {
    setLoadingStatuses(true);
    dispatch(getJobStatuses())
      .then((res) => {
        const list = res.payload?.data?.data || res.data?.data || (Array.isArray(res.payload?.data) ? res.payload.data : []);
        setJobStatuses(list);
        setCurrentPage(1);
      })
      .catch((err) => console.error("Error fetching job statuses:", err))
      .finally(() => setLoadingStatuses(false));
  };

  useEffect(() => {
    if (role === "superadmin" || role === "admin" || role === "restaurant") {
      fetchJobStatuses();
      dispatch(getAllRestaurants());
    }
  }, [role]);

  const getRestaurantName = (item) => {
    if (item.restaurantName) return item.restaurantName;
    const found = allRestaurants.find(
      (r) => String(r._id || r.id) === String(item.restaurantId)
    );
    return found ? found.name : item.restaurantId || "-";
  };

  const handleClick = () => {
    dispatch(generateRawMaterialData())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Data is not created."));
  };

  const handleClick1 = () => {
    dispatch(generateOrderSummaryData())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Data is not created."));
  };

  const handleClick2 = () => {
    dispatch(generateItemSummaryData())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Data is not created."));
  };

  const handleClick3 = () => {
    dispatch(moveTodayOrderToOrder())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Data is not moved."));
  };

  const handleClick4 = () => {
    dispatch(moveTodayExpensetoExpense())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Data is not moved."));
  };

  const handleClick5 = () => {
    dispatch(deleteTodayOrders())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Data is not deleted."));
  };

  const handleClick6 = () => {
    dispatch(deleteTodayExpenses())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Data is not deleted."));
  };

  const handleClick7 = () => {
    dispatch(generateDailyBalance())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Unsuccessful"));
  };

  const handleClick9 = () => {
    dispatch(resetKotValue())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Unsuccessful"));
  };

  const handleClick10 = () => {
    dispatch(deleteOldPdfOrders())
      .then((data) => alert(data.payload.data.message))
      .catch((data) => alert(data.payload.data?.message || "Unsuccessful"));
  };

  const intialFunction = () => {
    dispatch(
      getDashboard({
        role: role,
        restaurantId,
        branchId,
      })
    );
  };

  const renderBadge = (status) => {
    switch (status) {
      case "COMPLETED":
        return <Badge bg="success">COMPLETED</Badge>;
      case "IN_PROGRESS":
        return <Badge bg="primary">IN PROGRESS</Badge>;
      case "FAILED":
        return <Badge bg="danger">FAILED</Badge>;
      default:
        return <Badge bg="secondary">{status || "PENDING"}</Badge>;
    }
  };

  // Pagination Logic
  const totalItems = jobStatuses ? jobStatuses.length : 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentJobStatuses = jobStatuses ? jobStatuses.slice(indexOfFirstItem, indexOfLastItem) : [];

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <div>
      {remainingDays && (
        <SubscriptionExpireWarning remainingDays={remainingDays} />
      )}

      {CurrentReportData ? (
        <DashboardCreator
          reportInfo={CurrentReportData}
          reportData={data}
          initialEffectFunction={() => intialFunction()}
        />
      ) : (
        <Card className="mb-3">
          <Card.Body>No Data Available</Card.Body>
        </Card>
      )}

      {/* Manual Trigger Actions for Superadmin */}
      {role === "superadmin" && (
        <div className="mt-3 p-2 bg-light border rounded">
          <span className="text-muted small font-weight-bold d-block mb-2">
            Manual Actions (Superadmin):
          </span>
          <Button size="sm" onClick={handleClick}>
            Generate Raw Material
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick7}>
            Generate Daily Balance
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick1}>
            Generate Order Summary
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick2}>
            Generate Item Summary
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick3}>
            Move Today Order
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick4}>
            Move Today Expense
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick5}>
            Delete Today Order
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick6}>
            Delete Today Expense
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick9}>
            Reset Kot
          </Button>
          <Button size="sm" style={{ marginLeft: "5px" }} onClick={handleClick10}>
            Delete Old PDF Orders
          </Button>
        </div>
      )}

      {/* Maintenance Job Status Monitor */}
      <Card className="mt-4 shadow-sm">
        <Card.Header className="d-flex justify-content-between align-items-center bg-light">
          <h5 className="mb-0 text-dark font-weight-bold">
            <i className="mdi mdi-clock-check-outline me-2"></i>Daily Maintenance Job Status
          </h5>
          <Button
            size="sm"
            variant="outline-primary"
            onClick={fetchJobStatuses}
            disabled={loadingStatuses}
          >
            {loadingStatuses ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <i className="mdi mdi-refresh me-1">Refresh Status</i>
            )}
          </Button>
        </Card.Header>
        <Card.Body className="p-0">
          <Table responsive hover striped className="mb-0 align-middle">
            <thead className="table-dark">
              <tr>
                <th>Restaurant</th>
                <th>Process Step</th>
                <th>Status</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Duration (s)</th>
                <th>Details / Error</th>
              </tr>
            </thead>
            <tbody>
              {currentJobStatuses && currentJobStatuses.length > 0 ? (
                currentJobStatuses.map((item) => (
                  <tr key={item._id}>
                    <td className="font-weight-bold text-primary">{getRestaurantName(item)}</td>
                    <td className="font-weight-bold text-dark">{item.stepName}</td>
                    <td>{renderBadge(item.status)}</td>
                    <td>
                      {item.startTime
                        ? new Date(item.startTime).toLocaleString()
                        : "-"}
                    </td>
                    <td>
                      {item.endTime
                        ? new Date(item.endTime).toLocaleString()
                        : "-"}
                    </td>
                    <td>
                      {item.durationMs
                        ? (item.durationMs / 1000).toFixed(2)
                        : "-"}
                    </td>
                    <td>
                      {item.error ? (
                        <span className="text-danger small">{item.error}</span>
                      ) : (
                        <span className="text-muted small">OK</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-muted py-3">
                    No job status logs recorded yet today.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
        <Card.Footer className="d-flex justify-content-between align-items-center flex-wrap bg-light py-2">
          <div className="d-flex align-items-center gap-2 mb-2 mb-md-0">
            <span className="text-muted small">
              Showing {totalItems > 0 ? indexOfFirstItem + 1 : 0} to {Math.min(indexOfLastItem, totalItems)} of {totalItems} entries
            </span>
            <Form.Select
              size="sm"
              style={{ width: "80px", display: "inline-block", marginLeft: "10px" }}
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Select>
            <span className="text-muted small ms-1">per page</span>
          </div>

          <Pagination size="sm" className="mb-0">
            <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

            <Pagination.Item active>{currentPage} / {totalPages}</Pagination.Item>

            <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
            <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
          </Pagination>
        </Card.Footer>
      </Card>
    </div>
  );
};

export default Reports;
